export default function redirect(response) {
  const {
    json: { url, method },
  } = response;
  if (method === "GET") {
    document.location.href = url;
  } else {
    throw new Error(`Nieobsługiwany rodzaj przekierowania ${method}`);
  }
}
